import { useAuth } from '@/app/AuthContext.jsx';
import { useCan } from './useCan';

/**
 * Gate for the "encargado" (case assignee) controls. Business rule (USER-0010):
 * only admins modify the encargado — the API enforces it via the `case:assign`
 * permission on PATCH /cases/:caseId/assignee and POST /cases.
 *
 * In an individual org (`solo_law_firm`) the controls are hidden entirely: the
 * owner is implicitly in charge (the API auto-assigns at creation and refuses
 * unassign), so offering assign/cambiar there is noise.
 *
 * Builds on useCan for the permission read; owners resolve server-side, so
 * `isOwner` short-circuits.
 */
export default function useCanAssignCase() {
  const { activeCapability, isOwner } = useAuth();
  const canAssign = useCan('case:assign');
  if (activeCapability === 'solo_law_firm') return false;
  if (isOwner) return true;
  return canAssign;
}
